export { assetsConfig } from './assets-config';
